module.exports = __webpack_public_path__ + "static/media/notes.cbe4df50.svg";